import { Plus } from 'lucide-react';
import React, { useContext, useState } from 'react';
import { AutomationEditorContext } from '../AutomationEditorContext';
import styles from './AddStepButton.module.css';
import { AddStepMenu } from './AddStepMenu';

const { connector, isLast: isLastClass, dragOver: dragOverClass } = styles;

type OnAddStep = (actionType: string) => void;

export const AddStepButton: React.FC<{
  onAddStep: OnAddStep;
  isLast?: boolean;
  dropIndex: number;
}> = ({ onAddStep, isLast = false, dropIndex }) => {
  const { editor } = useContext(AutomationEditorContext)!;
  const { reorderActions } = editor;
  const [menuOpen, setMenuOpen] = useState(false);
  const [isDragOver, setIsDragOver] = useState(false);

  const closeMenu = setMenuOpen.bind(null, false);
  const openMenu = () => {
    setMenuOpen(true);
  };

  const onSelect = (actionType: string) => {
    onAddStep(actionType);
    closeMenu();
  };

  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    e.dataTransfer.dropEffect = 'move';
    setIsDragOver(true);
  };

  const handleDragLeave = (e: React.DragEvent) => {
    const currentTarget = e.currentTarget as HTMLElement;
    const relatedTarget = e.relatedTarget as HTMLElement | null;
    if (!currentTarget.contains(relatedTarget)) {
      setIsDragOver(false);
    }
  };

  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragOver(false);
    const draggedIndex = parseInt(e.dataTransfer.getData('text/plain') || '-1', 10);
    if (draggedIndex !== -1 && draggedIndex !== dropIndex) {
      reorderActions(draggedIndex, dropIndex);
    }
  };

  return (
    <div
      className={`${connector} ${isLast ? isLastClass : ''} ${isDragOver ? dragOverClass : ''}`}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}>
      <nav>
        <button onClick={openMenu} aria-label="Add step" type="button">
          <Plus />
          <span>Add step</span>
        </button>
        {menuOpen && <AddStepMenu onSelect={onSelect} onClose={closeMenu} />}
      </nav>
    </div>
  );
};
